import React from 'react';

import { Badge } from 'components/Badge';
import helpers from 'utils/helpers';

/**
 * Compact "Fatigued" badge for list rows. If the panelist is not held back
 * by any fatigue rule, renders nothing; otherwise the specific rule(s) are
 * shown on hover via title and read out to screen readers via visually
 * hidden text (e.g. "Respondent is in email fatigue"). Remaining props
 * (className, style, ...) are forwarded to Badge.
 *
 * @param {Object} props
 * @param {Object} props.panelist panelist
 */
export function FatigueBadge({ panelist, ...props }) {
    const reason = helpers.getPanelistEligibilityText(panelist);

    // If panelist is eligible, render nothing
    if (!reason) return null;

    return (
        <Badge {...props} type="warn" size="sm" title={reason}>
            Fatigued<span className="visually-hidden"> — {reason}</span>
        </Badge>
    );
}

export default FatigueBadge;
